import React from "react"
import Algorand from "./Algorand"
import Faq from "./FAQ"
import GetButton from "./GetButton"
import GetRJN from "./GetRJN"
import HowItWorks from "./HowItWorks"
import NFTIntro1 from "./NFTIntro1"
import NFTIntro2 from "./NFTIntro2"
import NFTList from "./NFTList"
import Roadmap from "./Roadmap"
import Social from "./Social"
import AirDrop from "./Airdrop"

const Body = () => {
  return (
    <div className="curved-div">
      <GetButton />
      <NFTIntro1 />
      <NFTIntro2 />
      <NFTList />
      <GetRJN />
      <AirDrop />
      <Algorand />
      <Roadmap />
      <Faq />
      <HowItWorks />
      <Social />
    </div>
  )
}

export default Body
